import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import PaginatedAanonymous from "../../../../components/tables/anonymousResult";
import Repository from "../../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { filterAndSplitJsonChoice } from "../../../../utility/helpers/filterJson";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import x_letter from "../../../../assets/icons/x_ letter.png";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";

const AnonymousResult = ({
    array,
    testType,
    note_id,
    isData,
    test_id,
    noteData,
    canDoIt,
    courseName,
    firstName,
    lastName,
    test_name,
    guid,
    score
}) => {
    const location = useLocation();

    const [loadingData, setLoadingData] = useState(true);
    const [showProblem, setShowProblem] = useState(false);
    const [resultData, setResultData] = useState("");
    const history = useHistory();
    const [collCount, setCollCount] = useState(0);

    function checkTypeTest(count) {
        if (testType.length > 1) {
            return `Multiple Choice - ${count} Questions`;
        } else {
            return `${testType[0]} - ${count} Questions`;
        }
    }
    function retunedScore() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < array[i].answers.length; j++) {
                if (
                    array[i].answers[j].correct == true &&
                    array[i].answers[j].correct ==
                        array[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }

        return countRightAnswer;
    }
    function score() {
        let countRightAnswer = retunedScore();

        return `Your Score: ${
            countRightAnswer +
            "/" +
            array.length +
            " (" +
            Math.floor((100 * countRightAnswer) / array.length) +
            "%)"
        }`;
    }



    return loadingData ? (
        showProblem ? (
            <div>
                <Card className="cardSection">
                    <CardBody className="cardBodiDiv">
                        <div>{resultData}</div>
                    </CardBody>
                </Card>
            </div>
        ) : (
            <div>
                <div className=" resultCard">
                    

                    <div className="accountingHeaderContentresulttest mt-5">
                        <h1>{test_name}</h1>
                    </div>
                    <div className="testType">
                        <div>
                            <span>{checkTypeTest(array.length)}</span>
                        </div>
                    </div>
                    <div className="accountingHeaderContentresulttest">
                        <h1>{score()}</h1>
                    </div>

                    <div className="pgItems">
                        <PaginatedAanonymous
                            itemsPerPage={4}
                            items={array}
                            test_id={test_id}
                            scoreResult={score}
                            isCreate={true}
                            testType={testType}
                            isData={isData}
                            note_id={note_id}
                            test_name={test_name}
                            courseName={courseName}
                            firstName={firstName}
                            lastName={lastName}
                            guid={guid}
                        />
                    </div>
                </div>
            </div>
        )
    ) : (
        <div>
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default AnonymousResult;
